import Skeleton from "react-loading-skeleton";

import Box from "ds/components/Box";
import PageInfoHeaderWrapper from "ds/components/PageInfoHeader/Wrapper";

const ProviderVersionDocsSkeleton = () => (
  <>
    <PageInfoHeaderWrapper>
      <Skeleton width={200} height={24} borderRadius={8} />
    </PageInfoHeaderWrapper>
    <Box grow="1" direction="column" padding="x-large" fullWidth scrollable surfaceColor="primary">
      <Box direction="column" gap="medium">
        <Skeleton width="90%" height={16} borderRadius={4} />
        <Skeleton width="95%" height={16} borderRadius={4} />
        <Skeleton width="85%" height={16} borderRadius={4} />
        <Skeleton width="92%" height={16} borderRadius={4} />
        <Skeleton width="88%" height={16} borderRadius={4} />
        <Skeleton width="94%" height={16} borderRadius={4} />
      </Box>
    </Box>
  </>
);

export default ProviderVersionDocsSkeleton;
